import { useState, useEffect, useRef, useCallback } from 'react';
import axios from 'axios';

const API_BACKEND = process.env.REACT_APP_SHOPKEEP_BACKEND || 'http://localhost:3001';

const useQuotaUsage = ({ user, getAuthHeaders, hasActiveSubscription }) => {
  const [quotaUsage, setQuotaUsage] = useState(null);
  const [loadingQuota, setLoadingQuota] = useState(false);
  const hasFetchedRef = useRef(false);

  const fetchQuotaUsage = useCallback(async () => {
    if (!user || !getAuthHeaders || !hasActiveSubscription) return;

    setLoadingQuota(true);
    try {
      const headers = await getAuthHeaders();
      const response = await axios.get(`${API_BACKEND}/api/account/quotas`, headers);
      if (response.data?.success) {
        setQuotaUsage(response.data.data);
      }
    } catch (err) {
      console.error('Error fetching quota usage:', err);
    } finally {
      setLoadingQuota(false);
    }
  }, [user, getAuthHeaders, hasActiveSubscription]);

  // Fetch once when user has an active subscription
  useEffect(() => {
    if (user && hasActiveSubscription && !hasFetchedRef.current) {
      hasFetchedRef.current = true;
      fetchQuotaUsage();
    }
    if (!user || !hasActiveSubscription) {
      hasFetchedRef.current = false;
    }
  }, [user, hasActiveSubscription, fetchQuotaUsage]);

  return { quotaUsage, loadingQuota, fetchQuotaUsage };
};

export default useQuotaUsage;
